/** Alliance manage page redesign — `redesign/alliance` + `redesign/panel` on Vercel blob. */
const REDESIGN_ALLIANCE =
  'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/redesign/alliance'
/** Panel frames / fills / corners — served from `public/assets/alliance-manage/` (CRA `PUBLIC_URL`). */
const PUBLIC_URL = process.env.PUBLIC_URL || ''
const REDESIGN_PANEL = 'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/land/alliance/alliance-manage'

export const ALLIANCE_MANAGE_ICON_DIPLOMACY_URL = `${REDESIGN_ALLIANCE}/alliance-diplomacy.webp`
export const ALLIANCE_MANAGE_ICON_MANAGEMENT_URL = `${REDESIGN_ALLIANCE}/alliance-management.webp`
export const ALLIANCE_MANAGE_ICON_OVERVIEW_URL = `${REDESIGN_ALLIANCE}/alliance-overview.webp`
export const ALLIANCE_MANAGE_ICON_TASKS_URL = `${REDESIGN_ALLIANCE}/alliance-tasks.webp`
/** Tasks tab — hero panel (scroll / quill crest). */
export const ALLIANCE_TASK_HERO_PANEL_ICON_URL = `${REDESIGN_ALLIANCE}/tasks-icons/alliance-task.webp`
/** Create panel — calendar next to start/end, war category chip, add-row buttons. */
export const ALLIANCE_TASK_ICON_CALENDAR_URL = `${REDESIGN_ALLIANCE}/tasks-icons/calendar.webp`
export const ALLIANCE_TASK_ADD_BUTTON_BG_URL = `${REDESIGN_ALLIANCE}/tasks-icons/add-task-btn.webp`
export const ALLIANCE_TASK_ICON_WAR_URL = `${REDESIGN_ALLIANCE}/tasks-icons/war.webp`
/** Create panel — category headers (War / Diplomacy / Technology). */
export const ALLIANCE_TASK_CATEGORY_WAR_URL = `${REDESIGN_ALLIANCE}/tasks-icons/category-war.webp`
export const ALLIANCE_TASK_CATEGORY_DIPLOMACY_URL = `${REDESIGN_ALLIANCE}/tasks-icons/category-diplomacy.webp`
export const ALLIANCE_TASK_CATEGORY_TECH_URL = `${REDESIGN_ALLIANCE}/tasks-icons/category-technology.webp`
export const ALLIANCE_TASK_ICON_REMAINING_TIME_URL = `${REDESIGN_ALLIANCE}/tasks-icons/remaining-time.webp`
export const ALLIANCE_TASK_ICON_GOVERNANCE_SCORE_URL = `${REDESIGN_ALLIANCE}/tasks-icons/governance-score.webp`
/** Create column — published period bands (`public/assets/alliance-manage/`). */
export const ALLIANCE_TASK_CREATE_START_BG_URL = `${REDESIGN_PANEL}/task-create-start-bg.webp`
export const ALLIANCE_TASK_CREATE_END_BG_URL = `${REDESIGN_PANEL}/task-create-end-bg.webp`
export const ALLIANCE_TASK_IMPACT_BG_URL = `${REDESIGN_PANEL}/task-impact-bg.webp`
/** Status ribbon when period is finalized / ended. */
export const ALLIANCE_TASK_FINALIZE_RIBBON_BG_URL = `${REDESIGN_PANEL}/task-finalize-bg.webp`
export const ALLIANCE_MANAGE_ICON_TECHNOLOGY_URL = `${REDESIGN_ALLIANCE}/alliance-technology.webp`
export const ALLIANCE_MANAGE_ICON_SETTINGS_URL = `${REDESIGN_ALLIANCE}/settings.webp`
export const ALLIANCE_MANAGE_ICON_TERRITORY_URL = `${REDESIGN_ALLIANCE}/alliance-territory.webp`
export const ALLIANCE_MANAGE_ICON_LIVE_MESSAGE_URL = `${REDESIGN_ALLIANCE}/live-message.webp`
export const ALLIANCE_MANAGE_ICON_REWARD_URL = `${REDESIGN_ALLIANCE}/reward.webp`
export const ALLIANCE_MANAGE_LEADER_SCORE_BADGE_URL = `${REDESIGN_ALLIANCE}/leader-score-badge.webp`
/** Overview — announcement panel centered crest / watermark (legacy / hero). */
export const ALLIANCE_ANNOUNCEMENT_BG_URL = `${REDESIGN_ALLIANCE}/announcement-bg.webp`
/** Overview — announcement body parchment + crest (`public/assets/alliance-manage/`). */
export const ALLIANCE_ANNOUNCEMENT_BODY_BG_URL = `${REDESIGN_PANEL}/alliance-announcement-bg.webp`
export const ALLIANCE_ANNOUNCEMENT_BODY_ICON_URL = `${REDESIGN_PANEL}/alliance-announcement-icon.webp`

/** Leave alliance — sidebar / join sheet (members only; not shown for leader row UI). */
export const ALLIANCE_MANAGE_LEAVE_URL = `${REDESIGN_ALLIANCE}/leave.webp`

/** Overview hero — right-side character art (transparent-friendly crop). */
export const ALLIANCE_OVERVIEW_GIRL_URL = `${REDESIGN_ALLIANCE}/alliance-girl.webp`

/** Overview hero panel — stats next to title / description (leader, members, diplomacy score). */
export const ALLIANCE_OVERVIEW_ICON_LEADER_URL = `${REDESIGN_ALLIANCE}/icon/leader-icon.webp`
export const ALLIANCE_OVERVIEW_ICON_MEMBER_URL = `${REDESIGN_ALLIANCE}/icon/member-icon.webp`
export const ALLIANCE_OVERVIEW_ICON_SCORE_URL = `${REDESIGN_ALLIANCE}/icon/score-icon.webp`
/** Rank role icons (management table select + bottom legend) — `redesign/alliance/icon/`. */
const ALLIANCE_ICON = `${REDESIGN_ALLIANCE}/icon`
export const ALLIANCE_MEMBER_RANK_ICONS: Record<string, string> = {
  sovereign: `${ALLIANCE_ICON}/sovereign.webp`,
  normal: `${ALLIANCE_ICON}/normal-user.webp`,
  regent: `${ALLIANCE_ICON}/regent.webp`,
  aegis: `${ALLIANCE_ICON}/aegis.webp`,
  nexus: `${ALLIANCE_ICON}/nexus.webp`,
  accord: `${ALLIANCE_ICON}/accord.webp`,
}

/** Full-bleed art for the alliance technology Pixi map (zoom / pan). */
export const ALLIANCE_TECHNOLOGY_BG_URL = `${REDESIGN_ALLIANCE}/technology/alliance-technology-bg.webp`

/** Per-building art: `{techId}.webp` under `redesign/alliance/technology/`. */
export const ALLIANCE_TECHNOLOGY_ART_BASE_URL = `${REDESIGN_ALLIANCE}/technology`

export function getAllianceTechnologyBuildingArtUrl(techId: string): string {
  return `${ALLIANCE_TECHNOLOGY_ART_BASE_URL}/${techId}.webp`
}

/** Main (right) column interior fill — `AllianceManageOrnamentedPanel` default `panelBgUrl` when `showInteriorFill` is true. */
export const ALLIANCE_MANAGE_PANEL_BG_URL = `${REDESIGN_PANEL}/right-panel-bg.webp`
/** Interior fill for the manage sidebar (nav) — parchment strip; corners/edges unchanged. */
export const ALLIANCE_MANAGE_NAVIGATION_PANEL_BG_URL = `${REDESIGN_PANEL}/navigation-panel-bg.webp`
/** Manage nav — selected tab row background (`public/assets/alliance-manage/tab-active-bg.webp`). */
export const ALLIANCE_MANAGE_NAV_TAB_ACTIVE_BG_URL = `${REDESIGN_PANEL}/tab-active-bg.webp`
export const ALLIANCE_MANAGE_PANEL_TOP_URL = `${REDESIGN_PANEL}/panel-top.webp`
export const ALLIANCE_MANAGE_PANEL_BOTTOM_URL = `${REDESIGN_PANEL}/panel-bottom.webp`
export const ALLIANCE_MANAGE_PANEL_LEFT_URL = `${REDESIGN_PANEL}/panel-left.webp`
export const ALLIANCE_MANAGE_PANEL_RIGHT_URL = `${REDESIGN_PANEL}/panel-right.webp`
/** Ornate corner art — `decorator-corner-*.webp` under `public/assets/alliance-manage/`. */
export const ALLIANCE_MANAGE_CORNER_TL_URL = `${REDESIGN_PANEL}/decorator-corner-top-left.webp`
export const ALLIANCE_MANAGE_CORNER_TR_URL = `${REDESIGN_PANEL}/decorator-corner-top-right.webp`
export const ALLIANCE_MANAGE_CORNER_BL_URL = `${REDESIGN_PANEL}/decorator-corner-bottom-left.webp`
export const ALLIANCE_MANAGE_CORNER_BR_URL = `${REDESIGN_PANEL}/decorator-corner-bottom-right.webp`

/** Right-panel card section titles — five-piece horizontal banner (`public/assets/alliance-manage/title-*.webp`). */
export const ALLIANCE_TITLE_BANNER_LEFT_CORNER_URL = `${REDESIGN_PANEL}/title-left-corner.webp`
export const ALLIANCE_TITLE_BANNER_LEFT_URL = `${REDESIGN_PANEL}/title-left.webp`
export const ALLIANCE_TITLE_BANNER_CENTER_URL = `${REDESIGN_PANEL}/title-center.webp`
export const ALLIANCE_TITLE_BANNER_RIGHT_URL = `${REDESIGN_PANEL}/title-right.webp`
export const ALLIANCE_TITLE_BANNER_RIGHT_CORNER_URL = `${REDESIGN_PANEL}/title-right-corner.webp`

/**
 * Warm parchment brown — manage nav dividers, borders, selected-tab inset glow (`rgba(r,g,b,α)`).
 * Replaces former hub gold `232, 201, 124`.
 */
export const ALLIANCE_MANAGE_NAV_ACCENT_RGB = '158, 118, 78'

const NAV = ALLIANCE_MANAGE_NAV_ACCENT_RGB

/** Management members tab — per-rank card frames + Donate / Kick art (`public/assets/alliance-manage/`). */
export const ALLIANCE_MEMBER_CARD_BORDER_LEADER_URL = `${REDESIGN_PANEL}/leader-border.webp`
export const ALLIANCE_MEMBER_CARD_BORDER_REGENT_URL = `${REDESIGN_PANEL}/regent-border.webp`
export const ALLIANCE_MEMBER_CARD_BORDER_AEGIS_URL = `${REDESIGN_PANEL}/aegis-border.webp`
export const ALLIANCE_MEMBER_CARD_BORDER_ACCORD_URL = `${REDESIGN_PANEL}/accord-border.webp`
export const ALLIANCE_MEMBER_CARD_BORDER_NEXUS_URL = `${REDESIGN_PANEL}/nexus-border.webp`
export const ALLIANCE_MEMBER_CARD_BORDER_NORMAL_URL = `${REDESIGN_PANEL}/normal-border.webp`
export const ALLIANCE_MEMBER_CARD_DONATE_BTN_BG_URL = `${REDESIGN_PANEL}/donate.webp`
export const ALLIANCE_MEMBER_CARD_KICK_BTN_BG_URL = `${REDESIGN_PANEL}/kick.webp`

/** Match management nav — borders on selects, tables, legend (same accent family as dividers). */
export const ALLIANCE_MANAGE_GOLD_BORDER = `rgba(${ALLIANCE_MANAGE_NAV_ACCENT_RGB}, 0.75)`
/** Single-line string — avoids odd parsing in some runtimes when used as inline style. */
export const ALLIANCE_MANAGE_NAV_ROW_DIVIDER_GRADIENT = `linear-gradient(90deg, rgba(${NAV}, 0) 0%, rgba(${NAV}, 0.16) 15%, rgba(${NAV}, 0.42) 40%, rgba(${NAV}, 0.62) 50%, rgba(${NAV}, 0.42) 60%, rgba(${NAV}, 0.16) 85%, rgba(${NAV}, 0) 100%)`

/** Vertical variant — between two columns (start / end dates). Same fade as nav row. */
export const ALLIANCE_MANAGE_NAV_COLUMN_DIVIDER_GRADIENT = `linear-gradient(180deg, rgba(${NAV}, 0) 0%, rgba(${NAV}, 0.16) 15%, rgba(${NAV}, 0.42) 40%, rgba(${NAV}, 0.62) 50%, rgba(${NAV}, 0.42) 60%, rgba(${NAV}, 0.16) 85%, rgba(${NAV}, 0) 100%)`

/** Same shape as nav divider, stronger peak — reads on busy `panel-bg` under section titles. */
export const ALLIANCE_MANAGE_PANEL_SECTION_DIVIDER_GRADIENT = `linear-gradient(90deg, rgba(${NAV}, 0) 0%, rgba(${NAV}, 0.34) 12%, rgba(${NAV}, 0.72) 38%, rgba(${NAV}, 0.9) 50%, rgba(${NAV}, 0.72) 62%, rgba(${NAV}, 0.34) 88%, rgba(${NAV}, 0) 100%)`
